import forEach from '../../../../javascripts/dom/forEach';

const galleries = document.querySelectorAll('[data-js-module="o-lightbox-gallery"]');

const lightboxes = document.querySelectorAll('[data-js-module="o-lightbox"]');

forEach(galleries, (index, element) => {
  const allLightboxConfigs = element.querySelectorAll('[data-js-lightbox-config]');
  const gallery = element;
  if (allLightboxConfigs.length) {
    require.ensure(
      [],
      require => {
        const PhotoSwipe = require('photoswipe');
        const PhotoSwipeUiDefault = require('photoswipe/dist/photoswipe-ui-default');
        const Lightbox = require('./lightbox').default;
        forEach(allLightboxConfigs, (index, configelement) => {
          new Lightbox(configelement, allLightboxConfigs, PhotoSwipe, PhotoSwipeUiDefault);
        });
      },
      'o-lightbox'
    );

    gallery.querySelector('.o-lightbox-gallery__cta-count').textContent = allLightboxConfigs.length;
    gallery.querySelector('.o-lightbox-gallery__cta-link').onclick = () => {
      gallery.querySelector('.o-lightbox-gallery__figure-1 a').click();
      return false;
    };
  }
});

forEach(lightboxes, (index, element) => {
  const allLightboxConfigs = element.querySelectorAll('[data-js-lightbox-config]');
  const gallery = element;
  if (allLightboxConfigs.length) {
    require.ensure(
      [],
      require => {
        const PhotoSwipe = require('photoswipe');
        const PhotoSwipeUiDefault = require('photoswipe/dist/photoswipe-ui-default');
        const Lightbox = require('./lightbox').default;
        forEach(allLightboxConfigs, (index, configelement) => {
          new Lightbox(configelement, allLightboxConfigs, PhotoSwipe, PhotoSwipeUiDefault);
        });
      },
      'o-lightbox'
    );
  }
});
